"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_request_1 = require("graphql-request");
var ramda_1 = require("ramda");
var graphQLClient = function (_a) {
    var baseURL = _a.baseURL, fetchOptions = _a.fetchOptions, params = _a.params, headers = _a.headers;
    var client = new graphql_request_1.GraphQLClient(baseURL, fetchOptions);
    client.setHeaders(headers);
    return client.rawRequest(params.query, params === null || params === void 0 ? void 0 : params.variables).catch(function (error) {
        var _a;
        if (!ramda_1.isNil((_a = error.response) === null || _a === void 0 ? void 0 : _a.data)) {
            return Promise.resolve(error.response);
        }
        return Promise.reject(error);
    });
};
exports.default = graphQLClient;
//# sourceMappingURL=graphQLClient.js.map